<div class="alert-settings-page p-6 flex-table-page" data-testid="alert-settings-page">
  <div class="mb-4 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ "alert_settings.title" | translate }}
    </h2>
  </div>

  <!-- Search Form -->
  <div class="mb-4">
    <app-search-form
      data-testid="alert-settings-search-form"
      [searchFormat]="searchFormConfig()"
      (formSearch)="onSearch($event)"
      (formReset)="onReset()"
    >
      <div slot="actions" class="flex gap-2">
        <app-button
          [testId]="'alert-settings-column-config-button'"
          type="success"
          [outlined]="true"
          icon="view_column"
          (emitOnClick)="onColumnConfigClick($event)"
        ></app-button>
        @if (canCreate()) {
          <app-button
            [testId]="'alert-settings-add-button'"
            [label]="'common.actions.new' | translate"
            type="info"
            (emitOnClick)="onAdd()"
          ></app-button>
        }
      </div>
    </app-search-form>
  </div>

  <!-- Alert Config Table -->
  <div class="flex-table-section">
    <advanced-data-table
      #advancedTable
      data-testid="alert-settings-table"
      [dataSource]="filteredConfigs()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [hasCheckColumn]="false"
      [showInternalColumnConfigButton]="false"
      [first]="page() * rows"
      [rows]="rows"
      [rowsPerPageOptions]="[20, 50, 100]"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
      class="w-full"
    >
      <!-- Custom Template for Date -->
      <ng-template
        #customTemplate
        let-value
        let-column="column"
        let-rowData="rowData"
      >
        @if (column && column.prop === "creationDate") {
          <span class="text-xs text-gray-600">
            {{ formatDateTime(rowData?.creationDate || value) }}
          </span>
        }
      </ng-template>

      <!-- Custom Actions Template -->
      <ng-template #actionsTemplate let-rowData>
        <div class="flex gap-2 justify-center">
          @if (canUpdate()) {
            <button
              type="button"
              [attr.data-testid]="'alert-settings-edit-button-' + rowData.id"
              (click)="onEdit(rowData)"
              class="action-link action-edit cursor-pointer"
            >
              {{ "common.actions.edit" | translate }}
            </button>
          }
          @if (canDelete()) {
            <button
              type="button"
              [attr.data-testid]="'alert-settings-delete-button-' + rowData.id"
              (click)="onDelete(rowData)"
              class="action-link action-delete cursor-pointer"
            >
              {{ "common.actions.delete" | translate }}
            </button>
          }
        </div>
      </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="alert-settings-toast"></p-toast>

<!-- Confirmation Dialog -->
<app-confirmation-dialog
  data-testid="alert-settings-confirmation-dialog"
  [visible]="showConfirmationDialog()"
  (visibleChange)="showConfirmationDialog.set($event)"
  [title]="confirmationTitle()"
  [message]="confirmationMessage()"
  [buttons]="[
    { label: 'common.actions.cancel', action: 'cancel', outlined: true },
    { label: 'common.actions.confirm', action: 'confirm', severity: 'danger' },
  ]"
  (emitOnClick)="onConfirmationDialogAction($event)"
></app-confirmation-dialog>
